import type { RouteRecordRaw } from 'vue-router';

export const patientsRoutes: RouteRecordRaw[] = [
  {
    path: 'patients',
    name: 'patients',
    component: () => import('./pages/PatientsListPage.vue'),
    meta: { title: 'Patients', requiresAuth: true, permission: 'view_patients' },
  },
  {
    path: 'patients/new',
    name: 'patients.create',
    component: () => import('./pages/PatientFormPage.vue'),
    meta: { title: 'New patient', requiresAuth: true, permission: 'create_patients' },
  },
  // Static segment before the `:id` wildcard.
  {
    path: 'patients/:id/edit',
    name: 'patients.edit',
    component: () => import('./pages/PatientFormPage.vue'),
    meta: { title: 'Edit patient', requiresAuth: true, permission: 'update_patients' },
  },
  {
    path: 'patients/:id',
    name: 'patients.show',
    component: () => import('./pages/PatientFormPage.vue'),
    meta: { title: 'Patient', requiresAuth: true, permission: 'view_patients' },
  },
];
